import {
  Button,
  Col,
  Form,
  Row,
  DatePicker,
  Input,
  Tooltip,
} from 'antd';
import NumericInput from 'components/NumericInput';
import Table from 'components/Table';
import React from 'react';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import { capitalize } from 'utils/normalizers';
import PropTypes from 'prop-types';
import currencyFormatter from 'utils/toCurrency';
import { descuentosRender } from 'views/Recaudacion/Caja/PanelPadron';

const TabAdeudo = ({
  form,
  currentEjecucion,
  _onFinish,
  loading,
  selectedRowKeys,
  handleOnClickCartera,
  mutable,
}) => {
  const columnsCargos = [
    {
      titleText: 'Clave TC',
      dataIndex: '',
      key: '',
      width: 150,
      render: (_, record) => record.tipo_de_cargo?.clave,
    },
    {
      titleText: 'Sistema',
      dataIndex: '',
      key: '',
      width: 200,
      render: (_, record) => record.tipo_de_cargo?.sistemas?.descripcion,
    },
    {
      titleText: 'Periodo',
      dataIndex: '',
      key: '',
      width: 350,
      render: (_, record) => record.tipo_de_cargo?.periodo_fiscal?.periodo,
    },
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 350,
    },
    {
      titleText: 'Adeudo Total',
      dataIndex: 'adeudo_total',
      key: 'adeudo_total',
      render: (val) => currencyFormatter(val),
      align: 'right',
      width: 150,
    },
    {
      titleText: 'Importe Base',
      dataIndex: 'importe',
      key: 'importe',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val),
    },
    {
      titleText: 'Actualización',
      dataIndex: 'actualizaciones_base',
      key: 'actualizaciones_base',
      width: 125,
      align: 'right',
      render: (txt, record) => {
        const _actualizaciones = record.actualizaciones
          .filter((r) => r.estados_globales !== 5 && !r.saldado);
        const actualizaciones = _actualizaciones.length
          ? _actualizaciones.filter((i) => !i.es_multa).map((r) => (
            <li key={r.id}>
              {`${r.descripcion}: ${currencyFormatter(r.importe_total)}`}
            </li>
          )) : null;

        return (
          <Tooltip title={actualizaciones?.length ? (<ul>{actualizaciones}</ul>) : null}>
            <span>{currencyFormatter(txt)}</span>
          </Tooltip>
        );
      },
    },
    {
      titleText: 'Recargos',
      dataIndex: 'recargos_base',
      key: 'recargos_base',
      width: 150,
      align: 'right',
      render: (txt, record) => {
        const _recargos = record.recargos.filter((r) => r.estados_globales !== 5 && !r.saldado);
        const recargos = _recargos.length
          ? _recargos.filter((i) => !i.es_multa).map((r) => (
            <li key={r.id}>
              {`${r.descripcion}: ${currencyFormatter(r.importe_total)}`}
            </li>
          )) : null;

        return (
          <Tooltip title={recargos?.length ? (<ul>{recargos}</ul>) : null}>
            <span>{currencyFormatter(txt)}</span>
          </Tooltip>
        );
      },
    },
    {
      titleText: 'Multa',
      dataIndex: 'multas_base',
      key: 'multas_base',
      width: 125,
      align: 'right',
      // render: multasRender,
      render: (txt, record) => {
        const _recargos = record.recargos.filter((r) => r.estados_globales !== 5 && !r.saldado);
        const recargosMultas = _recargos.filter((i) => i.es_multa);
        const _gastos = record.gastos.filter((g) => g.estados_globales !== 5 && !g.saldado);
        const gastosMultas = _gastos.filter((i) => i.es_multa);
        const recargos = recargosMultas.map((r) => (
          <li key={r.id}>
            {`${r.descripcion}: ${currencyFormatter(r.importe_total)}`}
          </li>
        ));
        const gastos = gastosMultas.map((g) => (
          <li key={g.id}>
            {`${g.descripcion}: ${currencyFormatter(g.importe)}`}
          </li>
        ));
        const allMultas = [...recargos, ...gastos];
        return (
          <Tooltip title={allMultas?.length ? (<ul>{allMultas}</ul>) : null}>
            <span>{currencyFormatter(txt)}</span>
          </Tooltip>
        );
      },
    },
    {
      titleText: 'Gastos',
      dataIndex: 'gastos_totales',
      key: 'gastos_totales',
      width: 125,
      align: 'right',
      // render: (txt, record) => renderAccesorios(txt, record, 'gastos'),
      render: (txt, record) => {
        const _gastos = record.gastos.filter((g) => g.estados_globales !== 5 && !g.saldado);
        const gastos = _gastos.filter((i) => !i.es_multa).map((g) => (
          <li key={g.id}>
            {`${g.descripcion}: ${currencyFormatter(g.importe)}`}
          </li>
        ));
        return (
          <Tooltip title={gastos?.length ? (<ul>{gastos}</ul>) : null}>
            <span>{currencyFormatter(txt)}</span>
          </Tooltip>
        );
      },
    },
    {
      titleText: 'Desc.',
      dataIndex: '_descuentos_totales_junto_accesorios',
      key: '_descuentos_totales_junto_accesorios',
      width: 125,
      align: 'right',
      render: descuentosRender,
    },
  ].filter((e) => e);

  const columnsCargosRead = [
    {
      titleText: 'Clave TC',
      dataIndex: 'datos_del_cargo_y_relacionados_json',
      key: 'datos_del_cargo_y_relacionados_json',
      width: 150,
      render: (text) => text?.tipo_de_cargo_clave,
    },
    {
      titleText: 'Sistema',
      dataIndex: 'datos_del_cargo_y_relacionados_json',
      key: 'datos_del_cargo_y_relacionados_json',
      width: 200,
      render: (text) => text?.sistema,
    },
    {
      titleText: 'Periodo',
      dataIndex: 'datos_del_cargo_y_relacionados_json',
      key: 'datos_del_cargo_y_relacionados_json',
      width: 150,
      render: (text) => text?.periodo_fiscal_anual,
    },
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 350,
      render: (_, record) => record._cargo?.descripcion
                        || record._cargo?.tipo_de_cargo,
    },
    {
      titleText: 'Adeudo Total',
      dataIndex: 'total_del_cargo',
      key: 'total_del_cargo',
      render: (val) => currencyFormatter(val),
      align: 'right',
      width: 150,
    },
    {
      titleText: 'Importe base',
      dataIndex: 'importe_de_cargo_base',
      key: 'importe_de_cargo_base',
      render: (val) => currencyFormatter(val),
      align: 'right',
      width: 150,
    },
    {
      titleText: 'Actualizaciones',
      dataIndex: 'importe_de_actualizacion',
      key: 'importe_de_actualizacion',
      render: (val) => currencyFormatter(val),
      align: 'right',
      width: 150,
    },
    {
      titleText: 'Recargos',
      dataIndex: 'importe_de_recargo',
      key: 'importe_de_recargo',
      render: (val) => currencyFormatter(val),
      align: 'right',
      width: 150,
    },
    {
      titleText: 'Multas',
      dataIndex: 'importe_de_gasto_multa',
      key: 'importe_de_gasto_multa',
      render: (val) => currencyFormatter(val),
      align: 'right',
      width: 150,
    },
    {
      titleText: 'Gastos',
      dataIndex: 'importe_de_gasto',
      key: 'importe_de_gasto',
      render: (val) => currencyFormatter(val),
      align: 'right',
      width: 150,
    },
    {
      titleText: 'Descuentos',
      dataIndex: '',
      key: '',
      align: 'right',
      width: 150,
      render: (_, record) => {
        const total = record.datos_del_cargo_y_relacionados_json?.total_descuentos_aplicados;
        if (total === undefined || total === null) {
          return currencyFormatter(0);
        }
        return currencyFormatter(total);
      },
    },
  ];

  return (
    <Form
      layout="vertical"
      name="adeudo_historico"
      form={form}
      onFinish={(_, _continue) => _onFinish(_continue)}
      scrollToFirstError
      forceRender
    >
      <br />
      <Row gutter={[10, 10]}>
        <Col xs={24} md={8}>
          <Form.Item
            name="fecha_de_obligacion_inicial_de_adeudos"
            label="F. Obligación inicial de adeudos"
          >
            <DatePicker
              allowClear
              disabled
              format={DATE_FRONTEND_FORMAT}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <NumericInput
            currency
            name="monto_del_adeudo"
            label="Total del adeudo"
            disabled
            tooltip="Este campo se llenará automaticamente una vez cargue la cartera"
          />
        </Col>
        {!selectedRowKeys.length && (
        <Col xs={24} md={8} style={{ display: 'flex', alignItems: 'center' }}>
          <Button
            block
            onClick={handleOnClickCartera}
          >
            Cargar Cartera
          </Button>
        </Col>
        )}
        <Col xs={24} md={16}>
          <Form.Item
            name="observaciones_del_adeudo"
            label="Observaciones del adeudo"
            normalize={(value) => capitalize(value)}
          >
            <Input.TextArea
              allowClear
              disabled={!mutable}
              autoSize={{ minRows: 3, maxRows: 6 }}
              maxLength={500}
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Table
            cols={selectedRowKeys.length ? columnsCargosRead : columnsCargos}
            mobileCols={selectedRowKeys.length
              ? columnsCargosRead.slice(0, 2) : columnsCargos.slice(0, 2)}
            data={currentEjecucion?.cargos}
            noControls
            allowSort={false}
            loading={loading}
            rowKey="id"
            emptyText="No se han cargado cargos"
            pageSize={currentEjecucion?.cargos?.length}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default TabAdeudo;

TabAdeudo.propTypes = {
  form: PropTypes.shape({
    getFieldsValue: PropTypes.func.isRequired,
  }).isRequired,
  formAdeudoHistorico: PropTypes.shape({}).isRequired,
  _onFinish: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  selectedRowKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleOnClickCartera: PropTypes.func.isRequired,
  mutable: PropTypes.bool.isRequired,
  formGeneral: PropTypes.shape({
    getFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  currentEjecucion: PropTypes.shape({
    cargos: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};
